import { useTranslation } from "react-i18next"

import { LanguageToggle } from "@/components/language-toggle"
import { ThemeToggle } from "@/components/theme-toggle"
import { LoginForm } from "@/features/auth/components/login-form"
import logoIndigo from "@/assets/logo-indigo.png"

export function LoginPage() {
  const { t } = useTranslation("auth")

  return (
    <div className="flex min-h-svh flex-col bg-background">
      <header className="relative flex items-center justify-center pt-12">
        <img src={logoIndigo} alt="Abeya" className="h-8 w-auto" />
        <div className="absolute top-4 right-4 flex items-center gap-1">
          <LanguageToggle />
          <ThemeToggle />
        </div>
      </header>

      <main className="flex flex-1 items-center justify-center px-6">
        <div className="w-full max-w-sm">
          <h1 className="mb-8 text-center text-2xl font-semibold tracking-tight">
            {t("login.title")}
          </h1>
          <LoginForm />
        </div>
      </main>

      <footer className="flex items-center justify-center gap-3 pb-8 text-sm text-muted-foreground">
        <a href="#" className="text-primary hover:underline">
          {t("login.termsOfUse")}
        </a>
        <span>|</span>
        <a href="#" className="text-primary hover:underline">
          {t("login.privacyPolicy")}
        </a>
      </footer>
    </div>
  )
}
